import ComoLlegarCta from '../ComoLlegarCta';
import ServiceBadges from '../ServiceBadges';
import { groupSchedules } from '../schedules';

/**
 * Tarjeta de punto HOP para la lista lateral.
 * Muestra nombre, dirección, horarios resumidos, reseller y CTA.
 *
 * @param {object} punto
 * @param {'geolocalizacion'|'direccion'} searchMethod
 * @param {number} [distance] - distancia en km si está disponible
 */
const PointCard = ({ punto, searchMethod = 'direccion', distance }) => {
  const schedules = groupSchedules(punto.schedules || []);
  return (
    <article className="bg-white border border-cyan-dark/10 rounded-[.8rem] p-14 shadow-[0px_8px_16px_0px_rgba(206,206,206,0.2)] hover:shadow-[0px_12px_24px_0px_rgba(206,206,206,0.3)] transition-shadow">
      <div className="flex items-start justify-between gap-8 mb-8">
        <div className="flex-1 min-w-0">
          <h3 className="p1 !text-14 sm:!text-16 !font-semibold text-black capitalize truncate">
            {punto.name}
          </h3>
          <p className="p1 !text-12 text-cyan-dark capitalize truncate">
            {punto.street} {punto.door_number}
          </p>
        </div>
        {distance != null && (
          <span className="shrink-0 inline-flex items-center gap-4 px-8 py-4 rounded-full bg-cyan-light text-cyan-dark text-10 font-semibold">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 24 24">
              <path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            </svg>
            {distance < 1 ? `${Math.round(distance * 1000)} m` : `${distance.toFixed(1)} km`}
          </span>
        )}
      </div>

      {punto.observations && (
        <p className="p1 !text-11 text-black opacity-50 mb-8 capitalize">{punto.observations}</p>
      )}

      <div className="mb-12">
        <p className="p1 !text-10 !font-semibold text-black opacity-30">HORARIOS</p>
        {schedules.length > 0 ? (
          schedules.map((schedule) => (
            <div
              key={`${schedule.day_description}-${schedule.intervals.join('|')}`}
              className="p1 !text-11 text-black flex justify-between gap-8"
            >
              <span>{schedule.day_description}</span>
              <span className="text-right">
                {schedule.intervals.map((interval) => (
                  <strong key={interval} className="block">
                    {interval}
                  </strong>
                ))}
              </span>
            </div>
          ))
        ) : (
          <p className="p1 !text-11 text-black opacity-60">Sin datos</p>
        )}
      </div>

      <ServiceBadges point={punto} className="mb-12" />

      <div className="flex items-center justify-between gap-8">
        <ComoLlegarCta punto={punto} source="lista" searchMethod={searchMethod} className="ml-auto" />
      </div>
    </article>
  );
};

export default PointCard;